import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Group, Image, NumberFormatter, Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import { gameOverview } from './data';
export const GameOverviewPanel: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Paper bg="transparent">
      <Stack gap={0}>
        <Group justify="space-between" h={50}>
          <Box>
            <Text fz={{
            base: 'sm',
            sm: 'lg',
            lg: 'xl'
          }} className={gunterzBold.className} c="var(--text-white)">
              {i18n._('Provider')}
            </Text>
            <Text fz="xs" c="var(--text-dark)" fw={700} tt="uppercase">
              {i18n._('pragmatic play')}
            </Text>
          </Box>
          <Image src="/assets/brand-logo.svg" alt="logo" />
        </Group>

        <Divider size="xs" color="var(--bg-400)" my={{
        base: 20,
        sm: 24,
        lg: 32
      }} />

        <SimpleGrid cols={2}>
          {gameOverview.map(item => <Box key={item.name}>
              <Text fz={{
            base: 'sm',
            lg: 'lg'
          }} className={gunterzBold.className} c="var(--text-white)">
                {item.name}
              </Text>

              {typeof item.value === 'string' ? <Text fz={{
            base: 'xs',
            sm: 'sm'
          }} c="var(--text-green)" fw={700} tt="uppercase">
                  {item.value}
                </Text> : <Text fz={{
            base: 'xs',
            sm: 'sm'
          }} c="var(--text-green)" fw={700} tt="uppercase">
                  <NumberFormatter value={item.value} decimalScale={2} decimalSeparator="." fixedDecimalScale />
                </Text>}
            </Box>)}
        </SimpleGrid>

        <Divider size="xs" color="var(--bg-400)" my={{
        base: 20,
        sm: 24,
        lg: 32
      }} />

        <SimpleGrid cols={2} spacing={{
        base: 10,
        lg: 20
      }}>
          <Paper p={{
          base: 10,
          lg: 16
        }} bg="var(--bg-400)">
            <Group justify="space-between" pos="relative">
              <Box>
                <Text className={gunterzBold.className} fz={{
                base: 'sm',
                lg: 'lg'
              }} c="var(--text-white)">
                  {i18n._('release date')}
                </Text>
                <Text fz="xs" c="var(--text-dark)" fw={700}>
                  {i18n._('27/06/2019')}
                </Text>
              </Box>
              <Image src="/assets/game-template/calender.svg" alt="calender" w={{
              base: 32,
              lg: 79
            }} h={{
              base: 32,
              lg: 79
            }} pos="absolute" right={0} />
            </Group>
          </Paper>

          <Paper p={{
          base: 10,
          lg: 16
        }} bg="var(--bg-400)">
            <Group justify="space-between" pos="relative">
              <Box>
                <Text className={gunterzBold.className} fz={{
                base: 'sm',
                lg: 'lg'
              }} c="var(--text-white)">
                  {i18n._('theme')}
                </Text>
                <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700}>
                  {i18n._('candy')}
                </Text>
              </Box>
              <Image src="/assets/game-template/candy.svg" alt="calender" w={{
              base: 40,
              lg: 94
            }} h={{
              base: 40,
              lg: 94
            }} pos="absolute" right={0} />
            </Group>
          </Paper>
        </SimpleGrid>
      </Stack>
    </Paper>;
};